module.exports = __webpack_public_path__ + "img/bg_Old.bdd056fb.png";